// import VideoCard from "./video-card";

import CGMVideoTutorialCard from "./CGMVideoTutorialCard";
import { EXTERNAL_URLS } from "src/constants/common";

const videoData = [
  {
    id: 1,
    title: "How CGM Works?",
    description: "Watch the full CGM setup journey",
    duration: "02 min watch",
    videoUrl: EXTERNAL_URLS.CGM_VIDEO_HOW_IT_WORKS,
    thumbnailUrl: "https://img.youtube.com/vi/Ek3QobtGoqM/hqdefault.jpg",
  },
  {
    id: 2,
    title: "How to Remove CGM?",
    description: "Step-by-step CGM removal guide",
    duration: "02 min watch",
    videoUrl: EXTERNAL_URLS.CGM_VIDEO_HOW_TO_REMOVE,
    thumbnailUrl: "https://img.youtube.com/vi/Ek3QobtGoqM/hqdefault.jpg",
  },
  {
    id: 3,
    title: "Troubleshooting Tips",
    description: "Fix sensor, sync or app issues",
    duration: "02 min watch",
    videoUrl: EXTERNAL_URLS.CGM_VIDEO_TROUBLESHOOTING,
    thumbnailUrl: "https://img.youtube.com/vi/Ek3QobtGoqM/hqdefault.jpg",
  },

  {
    id: 4,
    title: "Help & Support",
    description: "Contact us or get app support",
    duration: "02 min watch",
    videoUrl: EXTERNAL_URLS.CGM_VIDEO_HELP_SUPPORT,
    thumbnailUrl: "https://img.youtube.com/vi/Ek3QobtGoqM/hqdefault.jpg",
  },
];

interface CGMConnectVideoTutorialsProps {
  className?: string;
}

const CGMConnectVideoTutorials: React.FC<CGMConnectVideoTutorialsProps> = ({
  className,
}) => {
  return (
    <div className={`mt-16 ${className}`}>
      <h2 className="font-playfair font-semibold text-2xl leading-8 tracking-[0.25px] mb-1">
        Video Tutorials
      </h2>
      <p className="text-sm font-roboto mb-4 font-normal text-[14px] leading-[150%] tracking-[0.25px] text-[#667085]">
        Watch these curated videos to understand how to use your CGM
      </p>
      <div className="space-y-4">
        {videoData.map((video) => (
          <CGMVideoTutorialCard key={video.id} {...video} />
        ))}
      </div>
    </div>
  );
};

export default CGMConnectVideoTutorials;
